// --------------------------------------------------
//   Imports
// --------------------------------------------------


// React
import { createContext } from "react";

// Custom Scripts
import { LoadedData } from "./scripts/loadedData/loadedData";



// --------------------------------------------------
//   Main Content
// --------------------------------------------------


// Track the currently logged-in user
export const UserContext = createContext({
  userData:          LoadedData.NONE,
  refreshUserData:   () => {},
});
